import client from '../../utils/api'
import { createSlice } from '@reduxjs/toolkit'
import { createApiAction } from '../../utils/redux-tool'

const name = 'evaluation'
const initialState = {
  list: null,
}

export const search = createApiAction('evaluation/search', client.search('/api/setting/evaluation'))
export const get = createApiAction('evaluation/get', client.retrieve(`/api/setting/evaluation/:id`))
export const save = createApiAction('evaluation/save', client.save('/api/setting/evaluation'))
export const destroy = createApiAction('evaluation/delete', client.destroy('/api/setting/evaluation/:id'))

const update = (state, action) => {
  const found = state.list?.find(rec => rec.id === action.payload.id)
  if (state.list) {
    state.list = found
      ? state.list?.map(item => (found.id === item.id ? action.payload : item))
      : [...state.list, action.payload]
  }
}

const sessionSlice = createSlice({
  name,
  initialState,
  extraReducers(builder) {
    builder
      .addCase(search.fulfilled, (state, action) => {
        state.list = action.payload
      })
      .addCase(get.fulfilled, update)
      .addCase(save.fulfilled, update)
      .addCase(destroy.fulfilled, (state, action) => {
        state.list = state.list.filter(item => item.id !== action.payload.id)
      })
  },
})
export default sessionSlice.reducer
